var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('van-nav-bar',{attrs:{"title":"微考勤","left-text":""}}),_vm._v(" "),_c('van-overlay',{attrs:{"show":_vm.show}},[_c('div',{staticClass:"wrapper"},[_c('van-loading',{attrs:{"color":"#0094ff"}},[_vm._v("系统自动登录中...")])],1)])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0d8f8398","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/SSOLogin.vue
// module id = null
// module chunks = 